import { useCallback, useRef, type ReactNode } from 'react';
import type { RosterEntryFinalized } from '@discovr/types';
import { ConfirmedHoldDialogs, type HoldDialogsHandle } from './ConfirmedTab.holdDialogs';

interface ConfirmedHold {
  openHold: (row: RosterEntryFinalized, opener?: HTMLElement | null) => void;
  openRelease: (row: RosterEntryFinalized, opener?: HTMLElement | null) => void;
  dialogs: ReactNode;
}

// Dialog state lives in a child so opening a dialog does not re-render the
// table: cells remount when column inputs change, which would detach the
// menu trigger that focus must return to.
export function useConfirmedHold(): ConfirmedHold {
  const handle = useRef<HoldDialogsHandle>(null);
  const openHold = useCallback<ConfirmedHold['openHold']>((row, opener) => handle.current?.openHold(row, opener), []);
  const openRelease = useCallback<ConfirmedHold['openRelease']>((row, opener) => handle.current?.openRelease(row, opener), []);
  return { openHold, openRelease, dialogs: <ConfirmedHoldDialogs ref={handle} /> };
}
